const pointsOfInterest = [
    {
        id: `poi1`,
        latitude: 51.694822,
        longitude: -2.029724,
        title: `The Source of the Thames`,
        short_text: `The Thames is the longest river entirely in England.`,
        long_text: `The Thames rises at Thames Head in Gloucestershire and meanders 346kms where it eventually flows into the North Sea, via the Thames Estuary. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi2`,
        latitude: 51.645397,
        longitude: -1.953936,
        title: `Cotwolds Water Park`,
        short_text: `The Thames meanders through The Cotswolds Water Park, an area with 180 lakes.`,
        long_text: `The wetland landscape supported thousands of breeding waterfowl. The site is home to bats, water voles and otters. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi3`,
        latitude: 51.650082,
        longitude: -1.871948,
        title: `North Meadow, Cricklade`,
        short_text: `Famous for its thousands of Snake's head fritillaries, which bloom in April.`,
        long_text: `Meadows like North Meadow National Nature Reserve (NNR) were once common along the upper Thames. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi4`,
        latitude: 51.692757,
        longitude: -1.588195,
        title: `Radcot Bridge`,
        short_text: `Radcot Bridge is the oldest surviving bridge across the Thames`,
        long_text: `It was was the scene of a battle on 19th December 1387 between the forces of Richard II and Henry Bollingbroke, the future Henry IV. This battle raged along the Thames to Newbridge and finished at Bablock Hythe. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi5`,
        latitude: 51.689676,
        longitude: -1.678873,
        title: `St John's Bridge`,
        short_text: `The highest lock on the Thames is St John's Bridge.`,
        long_text: `It's a two-section road bridge across the channel of the upper Thames near Lechlade. This current bridge was built in 1886. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi6`,
        latitude: 51.766754,
        longitude: -1.284715,
        title: `Oxford`,
        short_text: `The Oxford stretch of the Thames is often referred to as the River Isis.`,
        long_text: `It was thought its original name Tamesis was a combination of Thame and Isis, this has turned out to be false. The name Isis has been used from its source in the Cotswolds until it is joined by the Thame at Dorchester in Oxfordshire. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi7`,
        latitude: 51.486284,
        longitude: -1.037242,
        title: `Mapledurham Water Mill`,
        short_text: `The famous film The Eagle has Landed was filmed in 1976 partly at Mapledurham Mill.`,
        long_text: `A mill was already present at Mapledurham at the time of the Domesday Book - a medieval survey completed in 1086. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi8`,
        latitude: 51.459061,
        longitude: -0.949945,
        title: `Reading`,
        short_text: `Here the River Kennet enters the Thames.`,
        long_text: `The Thames has 38 main tributaries feeding it between its source and Teddington. The Kennet is the largest. These tributaries contain a range of important habitats that support many species of wildlife, including water voles and otters. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi9`,
        latitude: 51.538124,
        longitude: -0.90012,
        title: `Henley-on-Thames`,
        short_text: `Just above Henley bridge is the headquarters of the Henley Royal Regatta`,
        long_text: `Below the bridge is the Leander Club, the most famous and successful rowing club in the world. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi10`,
        latitude: 51.53329,
        longitude: -0.69954,
        title: `Boulters Lock`,
        short_text: `A salmon ladder was opened at Boulters Weir on 19 May 2000 by the Duke of Wellington.`,
        long_text: `The last salmon caught before the salmon ladder at the weir was landed in 192. This was one of 20 ladders installed through funding from Thames Salmon Trust, now know as Thames Rivers Trust. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi11`,
        latitude: 51.486169,
        longitude: -0.607882,
        title: `Windsor Castle`,
        short_text: `Windsor Castle was the main residence for Queen Victoria and Prince Albert.`,
        long_text: `After Albert's death the queen was sometimes called the 'Widow of Windsor'. The castle is the largest inhabited castle in the world. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi12`,
        latitude: 51.447384,
        longitude: -0.563753,
        title: `Magna Carta Island`,
        short_text: `In 1215 King John signed the Magna Carta in a water meadow at Runnymede.`,
        long_text: `The exact location is unknow. This document limited the power of the monarch and gave legal rights to all. Noboby knows why a water meadow and Thames flood plain was chosen. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi13`,
        latitude: 51.418133,
        longitude: -0.513245,
        title: `Egham Hythe`,
        short_text: `Eels are a part of the Thames cultural heritage.`,
        long_text: `Every year young eels known as elvers arrive from the Sargasso Sea and swim up the Thames, however that journey is hindered by the many barriers on the river. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi14`,
        latitude: 51.403881,
        longitude: -0.337999,
        title: `Hampton Court Palace`,
        short_text: `When King Henry VIII left Hampton Court he often used the river Thames to get up to London.`,
        long_text: `Henry would travel in the royal barge. Built during Tudor times and given to Henry VIII by Cardinal Wolesey, this impressive palace overlooks the north bank of the Thames. Sourced by Thames Rivers Trust`,
        website_link: `https://www.thamesriverstrust.org.uk/`,
    },
    {
        id: `poi15`,
        latitude: 51.4315,
        longitude: -0.3239,
        title: `Teddington Lock`,
        short_text: `In February 2021, part of the Thames at Teddington Lock froze over for the first time in decades.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.standard.co.uk/news/uk/river-thames-frozen-teddington-lock-uk-temperatures-b919654.html`,
    },
    {
        id: `poi16`,
        latitude: 51.4452 - 0.3246,
        longitude: -0.3246,
        title: `Eel Pie Island`,
        short_text: `Eel Pie Island was a cradle for British rock n'roll, hosting the Rolling Stones in the summer of 1963.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.bbc.co.uk/news/entertainment-arts-44437317`,
    },
    {
        id: `poi17`,
        latitude: 51.4473,
        longitude: -0.3178,
        title: `Orleans House`,
        short_text: `Orleans House was a Palladian villa built in 1710 and so-called because the exiled Duc d'Orléans stayed there in 1813-15.`,
        long_text: `The octagon room of Orleans House and its service wing are listed Grade I by Historic England and, together, with a converted stable block, are now the Orleans House Gallery, an art gallery relating to the London Borough of Richmond upon Thames and neighbouring areas of London. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Orleans_House`,
    },
    {
        id: `poi18`,
        latitude: 51.4442,
        longitude: -0.3141,
        title: `Ham House`,
        short_text: `Ham House was one of the grandest houses in Stuart England.`,
        long_text: `Ham House is now run by the National Trust and its gardens are a must-visit in the spring. Sourced by Thames21`,
        website_link: `https://www.nationaltrust.org.uk/ham-house-and-garden/features/the-history-of-ham-house`,
    },
    {
        id: `poi19`,
        latitude: 51.4497,
        longitude: -0.3133,
        title: `Marble Hill House`,
        short_text: `Marble Hill was built for Henrietta Howard, Countess of Suffolk, who had been both Woman of the Bedchamber to Queen Caroline and mistress to King George II.`,
        long_text: `Henrietta Howard was known for her wit and corresponded with writers of the day like Jonathan Swift, Alexander Pope and John Gay. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Marble_Hill_House`,
    },
    {
        id: `poi20`,
        latitude: 51.446358,
        longitude: -0.303326,
        title: `Petersham Meadows`,
        short_text: `Each summer for the past 400 years, Petersham Meadows hosts a small herd of Belted Galloway cattle to enable the meadow to flourish.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.nationaltrust.org.uk/ham-house-and-garden/features/cattle-return-to-petersham-meadows-in-400-year-old-tradition-`,
    },
    {
        id: `poi21`,
        latitude: 51.45126594,
        longitude: -0.2968615153,
        title: `RSPCA Monument Richmond`,
        short_text: `This 100-year-old ornate Victorian structure celebrates the work of the Royal Society for the Prevention of Cruelty to Animals.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.featurepics.com/online/Landmark-Richmond-2800097.aspx`,
    },
    {
        id: `poi22`,
        latitude: 51.4521,
        longitude: -0.3021,
        title: `Buccleuch Gardens`,
        short_text: `During the medieval period, Buccleuch Gardens was common land of the Royal manor. The view from the terrace over the Thames was painted by Joshua Reynolds and JMW Turner.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://historicengland.org.uk/listing/the-list/list-entry/1001551`,
    },
    {
        id: `poi23`,
        latitude: 51.45725,
        longitude: -0.30732,
        title: `Richmond Road Bridge`,
        short_text: `Richmond Bridge is the oldest surving bridge across the Thames in London.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Richmond_Bridge,_London`,
    },
    {
        id: `poi24`,
        latitude: 51.45834643,
        longitude: -0.3091055499,
        title: `Corporation Island`,
        short_text: `One of the last photographs of The Beatles together was of the band sitting on Corporation Island in 1969.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Corporation_Island`,
    },
    {
        id: `poi25`,
        latitude: 51.46,
        longitude: -0.3136,
        title: `Richmond Railway Bridge`,
        short_text: `The present Richmond Railway Bridge was built in 1908 and leads to Richmond's Old Deer Park.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://historicengland.org.uk/listing/the-list/list-entry/1393016`,
    },
    {
        id: `poi26`,
        latitude: 51.4605314,
        longitude: -0.3143267307,
        title: `Twickenham Bridge`,
        short_text: `When it was being built, Twickenham Bridge became known as 'The Bridge that Nobody Wants', partly because on the Surrey side the approach cut through the Old Deer Park.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://historicengland.org.uk/listing/the-list/list-entry/1253011`,
    },
    {
        id: `poi27`,
        latitude: 51.46469539,
        longitude: -0.3105823939,
        title: `Old Deer Park`,
        short_text: `Two obelisks in the Old Deer Park were built in 1769 and were used by the King's Observatory to observe the transit of Venus across the Sun.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Old_Deer_Park`,
    },
    {
        id: `poi28`,
        latitude: 51.46236104,
        longitude: -0.3171940018,
        title: `Richmond Tidal Lock and Weir`,
        short_text: `Richmond Lock is the furthest downstream of the forty-five Thames locks and the only one owned and operated by the Port of London Authority.`,
        long_text: `Sourced by Thames21`,
        website_link: `http://www.pla.co.uk/About-Us/Richmond-Lock-and-Weir`,
    },
    {
        id: `poi29`,
        latitude: 51.4689,
        longitude: -0.3205,
        title: `Isleworth Ait`,
        short_text: `Isleworth Ait is a Local Nature Reserve, hosting 57 species of bird life, rare beetles and two rare species of air-breathing land gastropods.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Isleworth_Ait`,
    },
    {
        id: `poi30`,
        latitude: 51.4689,
        longitude: -0.3146,
        title: `King's Observatory`,
        short_text: `The King's Observatory was completed in 1769, in time for King George III to watch the transit of Venus on 3 June that year.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/King%27s_Observatory`,
    },
    {
        id: `poi31`,
        latitude: 51.4838,
        longitude: -0.2587,
        title: `Chiswick House`,
        short_text: `Visitors to Chiswick House include the composer Handel, C19th Whig MP Charles James Fox, and Queen Victoria and Prince Albert.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://chiswickhouseandgardens.org.uk/house-gardens/the-house/history-of-the-house/`,
    },
    {
        id: `poi32`,
        latitude: 51.4768,
        longitude: -0.3125,
        title: `Syon Park`,
        short_text: `Syon Park's flood meadows are some of the only original natural intertidal habitats left in London and are protected by law.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://londonist.com/london/secrets-of-syon-house-and-park`,
    },
    {
        id: `poi33`,
        latitude: 51.4787,
        longitude: -0.2956,
        title: `Kew Gardens`,
        short_text: `The Tea Pavillion in London's famous botanical gardens was burnt down by Suffragettes in 1913 after the Bill to give women the vote was withdrawn`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.kew.org/read-and-watch/kew-gardens-surprising-historical-facts`,
    },
    {
        id: `poi34`,
        latitude: 51.4846,
        longitude: -0.2984,
        title: `Lots Ait`,
        short_text: `Lots Ait was one of the last tidal boatyards to be closed in the early 1970's.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.lotsait.com/`,
    },
    {
        id: `poi35`,
        latitude: 51.4866,
        longitude: -0.2927,
        title: `Brentford Ait`,
        short_text: `Brentford Ait is home to a significant heronry.`,
        long_text: `Brentford Ait has a gap in the middle known as Hog Hole, at high tide it effectively becomes two islands. Sourced by Thames21`,
        website_link: `https://exploring-london.com/2018/04/25/10-islands-in-the-thames-3-brentford-ait/`,
    },
    {
        id: `poi36`,
        latitude: 51.4894,
        longitude: -0.2872,
        title: `Kew Bridge`,
        short_text: `When the first bridge on the site of Kew Bridge opened in 1759, over 3,000 people crossed in one day.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Kew_Bridge`,
    },
    {
        id: `poi37`,
        latitude: 51.485,
        longitude: -0.2812,
        title: `Oliver's Island`,
        short_text: `During the late 18th century Oliver’s Island had a tollbooth, a wooden structure shaped like a small castle, which levied charges on passing craft to raise money to pay for improvements to the river’s navigability`,
        long_text: `Sourced by Thames21`,
        website_link: `https://hidden-london.com/gazetteer/olivers-island/`,
    },
    {
        id: `poi38`,
        latitude: 51.4839,
        longitude: -0.2794,
        title: `Kew Railway Bridge`,
        short_text: `Kew Railway Bridge is the place where Doctor Who’s TARDIS materialises in a 1964 episode of the BBC sci-fi series.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.central-london-apartments.com/blog/from-london-bridge-to-battersea-bridge-31-things-you-didnt-know-about-londons-bridges/`,
    },
    {
        id: `poi39`,
        latitude: 51.4815,
        longitude: -0.2801,
        title: `The National Archives`,
        short_text: `The National Archives stores the UK's most important national documents. A recent study of its papers uncovered the extent of slave ownership in the UK.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://media.nationalarchives.gov.uk/index.php/outing-past-part-1-collecting-museum-transology/`,
    },
    {
        id: `poi40`,
        latitude: 51.4731,
        longitude: -0.2698,
        title: `Chiswick Bridge`,
        short_text: `Chiswick Bridge marks the finish point of the Championship Course for the Boat Race between the Universities of Oxford and Cambridge which has been held annually since 1856. The first Women's Boat Race took place in 1927 and moved to the Championship Course in 2015.`,
        long_text: `The record time over the Championship Course in the Men's Boat Race is 16 minutes 19 seconds, set by Cambridge in 1998 and for The Women's Boat Race is 18 minutes 33 seconds set by Cambridge in 2017.The first Women's Boat Race took place in 1927 and moved to the Championship Course in 2015. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/The_Boat_Race`,
    },
    {
        id: `poi41`,
        latitude: 51.4727,
        longitude: -0.2539,
        title: `Barnes Bridge`,
        short_text: `Barnes Bridge is only one of three bridges in London which is both a railway and a pedestrian bridge.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi42`,
        latitude: 51.48236457,
        longitude: -0.2479175307,
        title: `Leg o Mutton Pond`,
        short_text: `This disused resevoir was protected in the 1960s and now hosts nationally scarce birds such as pochard as well as protected great crested newts, bats, and bogbean aquatic plant.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Lonsdale_Road_Reservoir`,
    },
    {
        id: `poi43`,
        latitude: 51.482905,
        longitude: -0.247475,
        title: `Chiswick Eyot`,
        short_text: `Chiswick Eyot is the only island along the ‘Championship Course’ of the Oxford and Cambridge boat race.`,
        long_text: `Thames21 regularly works with volunteers to restore and protect Chiswick Eyot. Sourced by Thames21`,
        website_link: `http://www.ocps.btck.co.uk/Aboutourwork/ChiswickEyot`,
    },
    {
        id: `poi44`,
        latitude: 51.4881667,
        longitude: -0.2304444,
        title: `Hammersmith Bridge`,
        short_text: `Designed by Sir Joseph Bazalgette, Hammersmith Bridge has been closed for 2 years after cracks were found in its pedestal`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi45`,
        latitude: 51.48475,
        longitude: -0.22825,
        title: `Harrods Furniture Depository`,
        short_text: `When the Harrods Furniture Depository was completed in 1913, it housed the newest technology, such as reinforced concrete, lifts, and England’s first escalator.`,
        long_text: `Sourced by Thames21`,
        website_link: `http://www.storage.co.uk/blog/2011/03/storage-history-the-harrods-depository/`,
    },
    {
        id: `poi46`,
        latitude: 51.4766111,
        longitude: -0.2353056,
        title: `London Wetland Centre`,
        short_text: `The London Wetland Centre opened in 2000 and was formed of four disused Victorian reservoirs tucked into a loop in the Thames.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.wwt.org.uk/wetland-centres/london/`,
    },
    {
        id: `poi47`,
        latitude: 51.4889722,
        longitude: -0.2356667,
        title: `The Great Wet Wipe Reef of Barnes`,
        short_text: `A record 23,000 wet wipes were counted and removed here in just two hours in April 2019 by Thames21`,
        long_text: `So many wet wipes are entering the Thames that they are accumulating and changing the shape of the riverbed. A tangle of wet wipes has created a mound 1.5 high and larger than 2 tennis courts on the foreshore Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/2019/04/23-thousand-wet-wipes-discovered-stretch-thames-river-bank/`,
    },
    {
        id: `poi48`,
        latitude: 51.4785556,
        longitude: -0.2268889,
        title: `Steve Fairbairn Memorial`,
        short_text: `This memorial commemorates Steve Fairbairn, famous oarsman and coach, founder of the Head of the River Race and is exactly one mile from the start of the University Boat Race course.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.londonremembers.com/memorials/steve-fairbairn`,
    },
    {
        id: `poi49`,
        latitude: 51.475,
        longitude: -0.2216667,
        title: `Fulham Football Club`,
        short_text: `Fulham FC is London's oldest professional football club.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi50`,
        latitude: 51.4493,
        longitude: -0.2554,
        title: `Beverley Brook`,
        short_text: `Beverley Brook is so called because of the former presence in the river of beavers, a species extinct in Britain since the sixteenth century.`,
        long_text: `Beverley Brook, the goddess of the river, features as a character in Ben Aaronovitch's series of fantasy novels, Rivers of London. Sourced by Thames21`,
        website_link: `https://www.londonslostrivers.com/beverley-brook.html`,
    },
    {
        id: `poi51`,
        latitude: 51.4707,
        longitude: -0.216,
        title: `Fulham Palace`,
        short_text: `Archeological finds at Fulham Palace include artefacts from prehistoric, Roman, Saxon, Viking and Medieval times`,
        long_text: `The site at Fulham Palace has been the residence of the Bishops of London since AD 704. Sourced by Thames21`,
        website_link: `https://www.fulhampalace.org/house-garden/archaeology/`,
    },
    {
        id: `poi52`,
        latitude: 51.4668,
        longitude: -0.213,
        title: `Putney Bridge`,
        short_text: `Putney Bridge marks the start point for the Boat Race's Championship Course.`,
        long_text: `Putney Bridge was first built in 1729 out of wood and was the first bridge to be built over the Thames in central London after London Bridge. Sourced by Thames21`,
        website_link: `https://londonist.com/london/history/secrets-of-putney-bridge`,
    },
    {
        id: `poi53`,
        latitude: 51.4662778,
        longitude: -0.2093611,
        title: `Fulham Railway Bridge`,
        short_text: `Fulham Railway Bridge has no official name, but for over a hundred years it has been known as "The Iron Bridge".`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Fulham_Railway_Bridge`,
    },
    {
        id: `poi54`,
        latitude: 51.4655833,
        longitude: -0.2024444,
        title: `Hurlingham Club`,
        short_text: `The Hurlingham Club is an exclusive private members club situated by the Thames`,
        long_text: `In 1873, the club published the rules of polo, which are followed to this day, and is also a world centre for croquet. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/The_Hurlingham_Club`,
    },
    {
        id: `poi55`,
        latitude: 51.4651389,
        longitude: -0.188,
        title: `Wandsworth Bridge Road`,
        short_text: `The first bridge on the site was a toll bridge built in 1873, in the expectation that the western terminus of the Hammersmith and City Railway would shortly be built on the north bank and would lead to a sharp increase in the number of people wanting to cross the river. Sadly, the railway was never built.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Wandsworth_Bridge`,
    },
    {
        id: `poi56`,
        latitude: 51.467,
        longitude: -0.1822222,
        title: `Plantation Wharf Pier`,
        short_text: `You can hop on a Thames Clipper to commute along the Thames at Plantation Wharf Pier.`,
        long_text: `There are 10 residential boat moorings, each for 125 years, at Plantation Wharf Pier. Sourced by Thames21`,
        website_link: `https://www.plantationwharfpier.com/`,
    },
    {
        id: `poi57`,
        latitude: 51.4731389,
        longitude: -0.1793333,
        title: `Battersea Railway Bridge`,
        short_text: `Battersea Railway Bridge carries the London Overground line from Clapham Junction to Willesden Junction.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Battersea_Railway_Bridge`,
    },
    {
        id: `poi58`,
        latitude: 51.4778056,
        longitude: -0.1794722,
        title: `Chelsea Creek`,
        short_text: `Chelsea Creek was used by coal barges to to supply Lots Road Power Station and the Imperial Gas Works.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi59`,
        latitude: 51.4747222,
        longitude: -0.1802778,
        title: `Chelsea Harbour foreshore`,
        short_text: `Thames21 volunteers found a Saxon spearhead lying on the surface of the foreshore at Chelsea Harbour during a foreshore clean-up.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/`,
    },
    {
        id: `poi60`,
        latitude: 51.4816667,
        longitude: -0.1729722,
        title: `Battersea Bridge`,
        short_text: `A statue of the artist James McNeil Whistler stands on Battersea Bridge, the subject of one of his most famous paintings.`,
        long_text: `Thames21 is running two Big Wet Wipe counts on the foreshore at Battersea in 2021. Sign up now to help combat this damaging form of sewage-derived litter! Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/thames-river-watch/the-big-count/`,
    },
    {
        id: `poi61`,
        latitude: 51.4824,
        longitude: -0.1731,
        title: `Crosby Moran Hall`,
        short_text: `The Great Hall, built in 1466, is what remains of the medieval mansion of Crosby Hall, Bishopsgate, in the City of London.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Crosby_Hall,_London`,
    },
    {
        id: `poi62`,
        latitude: 51.4824722,
        longitude: -0.1667222,
        title: `Albert Bridge`,
        short_text: `Albert Bridge is painted pink, blue and green, to increase visibility in fog and murky light so that boats don't collide with it!`,
        long_text: `Sourced by Thames21`,
        website_link: `https://londonist.com/2016/10/secrets-of-albert-bridge`,
    },
    {
        id: `poi63`,
        latitude: 51.485,
        longitude: -0.1627778,
        title: `Chelsea Physic Garden`,
        short_text: `The Chelsea Physic Garden is London’s oldest botanic garden and contains a unique living collection of 5,000 edible, useful and medicinal plants that have changed the world.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.chelseaphysicgarden.co.uk/`,
    },
    {
        id: `poi64`,
        latitude: 51.4822222,
        longitude: -0.159,
        title: `The London Peace Pagoda`,
        short_text: `The Peace Pagoda was presented to Londoners by the Venerable Nichidatsu Fuji, founder of the Japanese Buddhist movement, in 1984.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.timeout.com/london/blog/five-things-you-should-know-about-the-peace-pagoda-in-battersea-012317`,
    },
    {
        id: `poi65`,
        latitude: 51.4842778,
        longitude: -0.1498333,
        title: `Chelsea Bridge`,
        short_text: `Chelsea Bridge was initially called Victoria Bridge, but the name was changed because it was structurally unsound, perhaps to avoid associating the Queen with any potential disaster.`,
        long_text: `When the first Chelsea Bridge was being constructed, Roman and Celtic artefacts and skeletons were found on the riverbed. Historians believe this was the site where Julius Caesar crossed the Thames during the 54 BC invasion of Britain. Sourced by Thames21`,
        website_link: `https://londonist.com/london/features/secrets-of-chelsea-bridge`,
    },
    {
        id: `poi66`,
        latitude: 51.4845,
        longitude: -0.1474444,
        title: `Grosvenor Railway Bridge`,
        short_text: `The Grosvenor Railway Bridge is the widest bridge on the Thames.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://londonist.com/london/transport/9-secrets-of-the-grosvenor-railway-bridge`,
    },
    {
        id: `poi67`,
        latitude: 51.4816667,
        longitude: -0.1447222,
        title: `Battersea Power Station`,
        short_text: `Battersea Power Station was once one of the world's largest brick buildings, but is now dwarfed by the new development around it.`,
        long_text: `Finished in 1935, Battersea Power Station is famous for its Art Deco interior fittings and decor. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Battersea_Power_Station`,
    },
    {
        id: `poi68`,
        latitude: 51.4876111,
        longitude: -0.2872222,
        title: `Strand-on-the-Green`,
        short_text: `Juvenile flounder, which have both eyes on one side of their head before one eye 'migrates' to the other side, are found at Strand-on-the-Green each year.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi69`,
        latitude: 51.4763056,
        longitude: -0.2498056,
        title: `Barnes`,
        short_text: `This strand at Barnes is the capital of plastic cups from pubs - 800 were found here in the 3 months after lockdown!`,
        long_text: `Join In the Drink, a campaign that aims to reduce or stop riverside pubs and cafes using single-use plastic cups and glasses! Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/joinacampaign/in-the-drink-stopping-the-deluge-of-plastic-cups/`,
    },
    {
        id: `poi70`,
        latitude: 51.4904444,
        longitude: -0.2341389,
        title: `Stamford Brook`,
        short_text: `Until the late 1920s, Stamford Brook had a 260m long open creek and at high tide water barges could enter the inlet and offload/onload cargo.`,
        long_text: `The mouth of Stamford Brook appears in Furnivall Gardens, which are named after Dr Frederick Furnivall, the co-founder of the Oxford English Dictionary. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi71`,
        latitude: 51.4692222,
        longitude: -0.1796944,
        title: `Falcon Brook`,
        short_text: `At the intersection of Valley Road and South Oak Road in Streatham, there is a manhole where you can usually hear Falcon Brook flowing beneath your feet.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi72`,
        latitude: 51.4778611,
        longitude: -0.1801389,
        title: `Counter's Creek`,
        short_text: `Counter's Creek has two of London's "Magnificent Cemetries" on its banks - Brompton and Kensal Green`,
        long_text: `Counter's Creek acts as the boundary between the boroughs of Hammersmith & Fulham and Kensington & Chelsea. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi73`,
        latitude: 51.485,
        longitude: -0.1538333,
        title: `River Westbourne`,
        short_text: `The Westbourne was formerly known as the River Serpentine as it fed water into the Serpentine Lake in Hyde Park.`,
        long_text: `The River Westbourne only flows into the Thames at times of heavy downpours. The outfall gate can best be viewed from Chelsea Bridge at low water. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi74`,
        latitude: 51.4705556,
        longitude: -0.2591667,
        title: `Agnes Beckwith`,
        short_text: `In 1878, Agnes Beckwith swam from Richmond to Westminster and back to Mortlake, covering 20 miles.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Agnes_Beckwith`,
    },
    {
        id: `poi75`,
        latitude: 51.483,
        longitude: -0.3017222,
        title: `Brent-Stoney Sluice`,
        short_text: `This the favoured location in the Thames of the endangered European Eel. Over 60,000 baby eels were recorded here in 2018 after swimming all the way from their spawning grounds in the Caribbean.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.zsl.org/sites/default/files/media/2018-12/ZSL%202018%20eel%20report_FINAL.pdf`,
    },
    {
        id: `poi76`,
        latitude: 51.4891667,
        longitude: -0.2286111,
        title: `Queen Caroline Drawdock`,
        short_text: `The first Thames21 foreshore litter pick was held at Queen Caroline Drawdock with the Hammersmith Civic Society.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/about-us/`,
    },
    {
        id: `poi77`,
        latitude: 51.4827222,
        longitude: -0.1320556,
        title: `US Embassy`,
        short_text: `The Embassy of the United States of America in London is the largest American embassy in Western Europe.`,
        long_text: `The building's design, a crystalline cube, gives form to the core democratic values of transparency, openness, and equality. Donald Trump described it as a 'bad deal' in an 'off location' and refused to attend the opening ceremony to cut the ribbon. Sourced by Thames21`,
        website_link: `https://uk.usembassy.gov/our-relationship/policy-history/new-embassy/`,
    },
    {
        id: `poi78`,
        latitude: 51.4911111,
        longitude: -0.1278056,
        title: `Tate Britain`,
        short_text: `Tate Britain in Millbank opened in 1897 and now houses British Art from 1545 to the present day.`,
        long_text: `The Tate Millbank was built after a public campaign to raise money so that it could house the art collection that sugar magnate Henry Tate had donated. Sourced by Thames21`,
        website_link: `https://www.tate.org.uk/about-us/history-tate`,
    },
    {
        id: `poi79`,
        latitude: 51.4922222,
        longitude: -0.1261111,
        title: `Millbank Tower`,
        short_text: `When Millbank Tower was built in 1963, it was briefly the UK's tallest building, until the BT Towerwas built in 1964.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Millbank_Tower`,
    },
    {
        id: `poi80`,
        latitude: 51.4875278,
        longitude: -0.1268889,
        title: `Vauxhall Bridge`,
        short_text: `In the nineteenth century, crowds would gather on Vauxhall Bridge to watch hot air ballons being launched from Vauxhall Pleasure Gardens.`,
        long_text: `Vauxhall Bridge is Grade II* listed, and carries a Cycle Superhighway across the Thames, as well as the A202. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Vauxhall_Bridge`,
    },
    {
        id: `poi81`,
        latitude: 51.4938889,
        longitude: -0.1255556,
        title: `Thames House`,
        short_text: `The MI6 building has housed the UK's Secret Intelligence Service since 1994 and features in several James Bond films, including as a backdrop to a high speed boat chase in Spectre.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/SIS_Building#James_Bond_films`,
    },
    {
        id: `poi82`,
        latitude: 51.4880556,
        longitude: -0.1247222,
        title: `Slipway between M15 & Camelford house`,
        short_text: `One of the strangest foreshore finds by river charity Thames21's volunteers was here - an unopened tin of US coastguard emergency drinking water stamped 1956.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/events/`,
    },
    {
        id: `poi83`,
        latitude: 51.4945556,
        longitude: -0.1229444,
        title: `Lambeth Bridge`,
        short_text: `In 1965, Lambeth Bridge became the first of London's crossings to be tunnelled beneath so that people can walk along the Embankment.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://londonist.com/london/history/secrets-of-lambeth-bridge`,
    },
    {
        id: `poi84`,
        latitude: 51.4955556,
        longitude: -0.1197222,
        title: `Lambeth Palace`,
        short_text: `For nearly 800 years, Lambeth Palace has been the London residence of the Archbishop of Canterbury.`,
        long_text: `The name "Lambeth" embodies "hithe", a landing on the river. For centuries, archbishops came and went by water. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Lambeth_Palace`,
    },
    {
        id: `poi85`,
        latitude: 51.497,
        longitude: -0.1248889,
        title: `Victoria Tower Gardens`,
        short_text: `Victoria Tower Gardens were created during the 1870s by Joseph Bazalgette.`,
        long_text: `Victoria Tower Gardens is a public park and a Conservation Area, partly within the UNESCO World Heritage Site of Westminster. It houses the momument to Sir Thomas Peirson Frank who oversaw the secret response to over 100 incidents of bomb damage to the Thames wall which required rapid repair during WWII. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Victoria_Tower_Gardens`,
    },
    {
        id: `poi86`,
        latitude: 51.4995,
        longitude: -0.1248,
        title: `Houses of Parliament`,
        short_text: `The Palace of Westminster is the official name of the building in which both Houses of Parliament meet and which features the iconic clock known as 'Big Ben'.`,
        long_text: `MPs had to move out of Westminster Palace in 1858 due to the stench of excrement in the river, leading to the building of the modern sewage system Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Great_Stink`,
    },
    {
        id: `poi87`,
        latitude: 51.51,
        longitude: -0.1011111,
        title: `Usher the Clown`,
        short_text: `In 1815, a man known as Usher the Clown floated down the river in a washing tub pulled by four geese, all the way from Southwark Bridge to Vauxhall.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.waterloofestival.com/post/the-story-of-waterloo-5-usher-the-clown-and-his-geese`,
    },
    {
        id: `poi88`,
        latitude: 51.5008889,
        longitude: -0.1215278,
        title: `Westminster Bridge`,
        short_text: `The latest version of Westminster Bridge opened in 1862, making it the oldest surviving road bridge across the Thames in central London.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://londonist.com/2016/08/secrets-of-westminster-bridge`,
    },
    {
        id: `poi89`,
        latitude: 51.5033056,
        longitude: -0.1196111,
        title: `London Eye`,
        short_text: `Opened in the year 2000, the London Eye quickly became an iconic part of London's skyline. Over 3 million people look over London from it every year.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi90`,
        latitude: 51.5061111,
        longitude: -0.1201111,
        title: `Hungerford Bridge & Golden Jubilee Bridges`,
        short_text: `Hungerford Bridge was designed by Isambard Kingdom Brunel and opened in 1845 as a suspension footbridge.`,
        long_text: `In 1859 Hungerford Bridge also became a railway bridge, bringing the South Eastern Railway into the newly opened Charing Cross railway station. The footbridges were re-named the Golden Jubilee Bridges on the 50th anniversary of Queen Elizabeth II's accession. Sourced by Thames21`,
        website_link: `https://london.wikia.org/wiki/Hungerford_Bridge`,
    },
    {
        id: `poi91`,
        latitude: 51.5080556,
        longitude: -0.1216667,
        title: `Cleopatra's Needle`,
        short_text: `Cleopatra's Needle is 3,500 years old and was brought to London from Alexandria in 1877.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi92`,
        latitude: 51.51,
        longitude: -0.1225,
        title: `The Strand`,
        short_text: `The Strand is named after the strand, or shoreline, of the Thames. Saxons would pull boats up to the strand line instead of using a dock.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi93`,
        latitude: 51.5091667,
        longitude: -0.1173889,
        title: `Waterloo Bridge`,
        short_text: `Waterloo Bridge also bears the nickname 'The Ladies' Bridge' as it was built by a largely female workforce during the Second World War.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.central-london-apartments.com/blog/from-london-bridge-to-battersea-bridge-31-things-you-didnt-know-about-londons-bridges/`,
    },
    {
        id: `poi94`,
        latitude: 51.5061111,
        longitude: -0.1163056,
        title: `South Bank Centre`,
        short_text: `The Royal Festival Hall was built for the Festival of Britain, intended to be 'a tonic for the nation' and raise the spirits during postwar austerity, in 1951.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Southbank_Centre`,
    },
    {
        id: `poi95`,
        latitude: 51.5071944,
        longitude: -0.1143889,
        title: `The National Theatre`,
        short_text: `The first performance in the newly-built National Theatre was Hamlet, starring Peter O'Toole, on 22 October, 1963.`,
        long_text: `The National Theatre's 'brutalist' modernist building was designed by Sir Denys Lasdun and opened in 1976. Sourced by Thames21`,
        website_link: `https://www.nationaltheatre.org.uk/about-the-national-theatre/history`,
    },
    {
        id: `poi96`,
        latitude: 51.5083333,
        longitude: -0.1102778,
        title: `Gabriel's Wharf`,
        short_text: `A beach was created for the Festival of Britain in 1951 by laying sand at Gabriel's Wharf. It still exists and is a popular spot for sand sculptors.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi97`,
        latitude: 51.5095,
        longitude: -0.1043333,
        title: `Blackfriars Bridge`,
        short_text: `The hidden river Fleet, which rises in Hampstead Heath and gives Fleet Street its name, joins the Thames under Blackfriars Bridge`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi98`,
        latitude: 51.5138,
        longitude: -0.0984,
        title: `St Paul's Cathedral`,
        short_text: `A Cathedral dedicated to St Paul has stood on this site, the highest point of the City of London, for over 1,400 years.`,
        long_text: `The copper pineapple on top of the Cathedral's south-west tower was created by female Coppersmith, Jane Brewer, in 1707 Sourced by Thames21`,
        website_link: `https://www.stpauls.co.uk/`,
    },
    {
        id: `poi99`,
        latitude: 51.5083333,
        longitude: -0.1083333,
        title: `Oxo Tower`,
        short_text: `The architect of the Oxo Tower circumnavigated a ban on advertising on the Thames front by designing windows so they spell 'Oxo' when lit up at night.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://hidden-london.com/nuggets/oxo-tower/`,
    },
    {
        id: `poi100`,
        latitude: 51.5100556,
        longitude: -0.0985,
        title: `Millenium Bridge`,
        short_text: `The Millennium Bridge was the first new bridge to be built over the Thames in London for more than 100 years.`,
        long_text: `There are around 400 tiny works of art on the Millennium Bridge. The 'Chewing Gum Artist' painted these minuscule masterpieces onto the chewing gum dropped by other people. Sourced by Thames21`,
        website_link: `https://londonist.com/london/features/millennium-bridge-trivia`,
    },
    {
        id: `poi101`,
        latitude: 51.5081111,
        longitude: -0.0971944,
        title: `Shakespeare's Globe`,
        short_text: `Shakespeare's Globe is a reconstruction of the original Globe Theatre which was in Shoreditch. The first play to be performed at the original Globe theatre was probably Julius Caesar, in 1599.`,
        long_text: `William Shakespeare was a shareholder who owned 12.5% of the original Globe Theatre. Colour coded flags were used outside the Theatre to advertise the type of play to be performed – a red flag for a history, white for a comedy and black for a tragedy. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi102`,
        latitude: 51.5076111,
        longitude: -0.0993889,
        title: `Tate Modern`,
        short_text: `Bankside, formerly a coal-fired power station, became the Tate Modern, one of the world's foremost modern art galleries, in the year 2000.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi103`,
        latitude: 51.5069444,
        longitude: -0.0902778,
        title: `Queenhithe`,
        short_text: `The area of Thames foreshore called Queenhithe is an ancient dock, probably Roman, and by Saxon times known as Ethelred's Hythe.`,
        long_text: `Queenhithe is the only remaining inlet on the modern City's waterfront and became a scheduled monument in 1973. Mudlarking is still prohibited on this foreshore, but the charity Thames21 runs regular litter monitoring and clearing activities here as it is one of central London's 'floating litter hotspots'. Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/thames-river-watch/`,
    },
    {
        id: `poi104`,
        latitude: 51.5090833,
        longitude: -0.0939444,
        title: `Southwark Bridge`,
        short_text: `Southwark Bridge has the reputation of it being the least used bridge in central London and it is sometimes known as the "car park bridge" as coach drivers use it to park their vehicles.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://london.wikia.org/wiki/Southwark_Bridge`,
    },
    {
        id: `poi105`,
        latitude: 51.5095556,
        longitude: -0.0926111,
        title: `Walbrook Wharf`,
        short_text: `Walbrook Wharf is central London's only remaining working dock, from which City of London waste is moved by barge downstream to the Belvedere Incinerator, beyond the Thames Barrier.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Walbrook_Wharf`,
    },
    {
        id: `poi106`,
        latitude: 51.51,
        longitude: -0.092,
        title: `River Walbrook`,
        short_text: `River Walbrook is one of London's most ancient hidden or 'lost' rivers, which once ran aboveground, but which was covered over as it became heavily polluted.`,
        long_text: `The name Walbrook is thought to originate from the fact that the river ran through the London Wall – a defensive wall built by the Romans around London. Sourced by Thames21`,
        website_link: `https://www.londonslostrivers.com/river-walbrook.html`,
    },
    {
        id: `poi107`,
        latitude: 51.5113889,
        longitude: -0.0903056,
        title: `Cannon Street Bridge`,
        short_text: `Cannon Street Bridge is part of the Illuminated River project, where bridges are lit at night. For Cannon Street Bridge, the artist, Leo Villareal, chose subtle kinetic colours which mirror the motion of the trains passing above.`,
        long_text: `Cannon Street got its name as a shortening of the Middle English ‘candelwrichstrete’ which means ‘street of candle makers,’ first noted in the 12th Century. Sourced by Thames21`,
        website_link: `https://illuminatedriver.london/bridges/cannon-street-railway-bridge`,
    },
    {
        id: `poi108`,
        latitude: 51.5044444,
        longitude: -0.0863889,
        title: `The Shard`,
        short_text: `The Shard, 309.6 metres (1,016 ft) high with 72 floors and a spire, was completed in 2012.`,
        long_text: `In July 2019, 19-year-old George King 'freeclimbed' the Shard, without ropes or suction cups, in 45 minutes. London Bridge Station was closed for fears for the safety of the then-unidentified climber and commuters. He was met by police at the top. Sourced by Thames21`,
        website_link: `https://www.the-shard.com/`,
    },
    {
        id: `poi109`,
        latitude: 51.5081944,
        longitude: -0.0876389,
        title: `London Bridge`,
        short_text: `The site of the medieval 'London Bridge' is marked by the church of St Magnus-the-Martyr on the northern bank and by Southwark Cathedral.`,
        long_text: `In 1968, the City of London sold what was then London Bridge to Missourian entrepreneur Robert P. McCulloch for US$2,460,000. The bridge was dismantled, shipped via the Panama Canal to California, and then trucked to Arizona, where the bridge was re-assembled over the Bridgewater Canal at Lake Havasu City. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/London_Bridge#Sale_to_Robert_McCulloch`,
    },
    {
        id: `poi110`,
        latitude: 51.505,
        longitude: -0.0733333,
        title: `Pool of London`,
        short_text: `The Pool of London is a stretch of the River Thames from London Bridge to below Limehouse. Part of the Tideway of the Thames, the Pool was navigable by tall-masted vessels bringing coastal and later overseas goods and was part of the original Port of London.`,
        long_text: `In 1586, the Pool of London was so busy with boats that William Camden boasted: “A man would say, that seeth the shipping there, that it is, as it were, a very wood of trees disbranched to make glades and let in light, so shaded it is with masts and sails.” Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Pool_of_London`,
    },
    {
        id: `poi111`,
        latitude: 51.5065833,
        longitude: -0.0811667,
        title: `HMS Belfast`,
        short_text: `HMS Belfast is one of only three remaining vessels from the bombardment fleet which supported the Normandy landings on 6 June 1944.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.iwm.org.uk/visits/hms-belfast/about`,
    },
    {
        id: `poi112`,
        latitude: 51.5069444,
        longitude: -0.0902778,
        title: `The Golden Hind`,
        short_text: `Sir Francis Drake sailed round the world in the Golden Hind between 1577 and 1580.`,
        long_text: `As well as crew, the ship's company also included archers, musicians and gentlemen adventurers. Sourced by Thames21`,
        website_link: `https://www.goldenhinde.co.uk/discover`,
    },
    {
        id: `poi113`,
        latitude: 51.5081111,
        longitude: -0.0758889,
        title: `Tower of London`,
        short_text: `The Tower of London was built by William the Conqueror in 1078.`,
        long_text: `When Anne Boleyn was arrested in 1536 she was taken to the Tower by barge, and passed through Traitor's Gate to await her trial and execution. However, she was allowed to sleep in the chamber in which she slept the night before her wedding to King Henry VIII. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi114`,
        latitude: 51.5055,
        longitude: -0.0753889,
        title: `Tower Bridge`,
        short_text: `In 1952 a bus caught on Tower Bridge as it opened successfully jumped the gap by accelerating`,
        long_text: `Sourced by Thames21`,
        website_link: `https://factcity.com/facts-about-tower-bridge/`,
    },
    {
        id: `poi115`,
        latitude: 51.5008333,
        longitude: -0.0621944,
        title: `Bermondsey Beach`,
        short_text: `Bermondsey Beach was officially opened on 23rd July 1934 and saw over 500,000 visitors between 1934 and 1939`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.mylondon.news/whats-on/whats-on-news/london-beach-forgotten-river-thames-16787837`,
    },
    {
        id: `poi116`,
        latitude: 51.503,
        longitude: -0.0543611,
        title: `Thames Tunnel`,
        short_text: `The Thames Tunnel is the world's first underwater tunnel built by Marc and Isambard Brunel. It was initially designed as a foot tunnel, but eventually became part of the London Underground system.`,
        long_text: `Sourced by Thames21`,
        website_link: `http://www.ikbrunel.org.uk/thames-tunnel`,
    },
    {
        id: `poi117`,
        latitude: 51.5093056,
        longitude: -0.0493333,
        title: `King Edward Memorial Park`,
        short_text: `King Edward Memorial Park is the location of one of the most polluting sewer overflows into the river. The new Tideway Tunnel will divert the sewage into the new super sewer 60m below.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.tideway.london/locations/king-edward-memorial-park-foreshore/`,
    },
    {
        id: `poi118`,
        latitude: 51.5075278,
        longitude: -0.0485,
        title: `Rotherhithe Tunnel`,
        short_text: `Rotherhithe Tunnel is an extremely rare example of a road tunnel where road traffic, pedestrians and cyclists all share the same tunnel bore.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi119`,
        latitude: 51.5072222,
        longitude: -0.0466667,
        title: `Shadwell Basin`,
        short_text: `Shadwell Basin used to be part of the former London Docks and is used today for sailing, fishing,and kayaking.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Shadwell_Basin`,
    },
    {
        id: `poi120`,
        latitude: 51.51,
        longitude: -0.0327778,
        title: `Ropemaker's Fields`,
        short_text: `Ropemaker's Fields marks where ropes for marine anchors, rigging and mining was made for many centuries. Samuel Pepys and Tsar Alexander II of Russia both visited ropemakers here.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.parksandgardens.org/places/ropemakers-fields`,
    },
    {
        id: `poi121`,
        latitude: 51.5051944,
        longitude: -0.0229722,
        title: `Canary Wharf`,
        short_text: `Canary Wharf is now a global financial centre. Redevelopment of this formerly deprived area of London which suffered heavy air raids on World War Two, started in 1987.`,
        long_text: `When One Canada Square was completed in 1991, it was the UK's tallest building. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi122`,
        latitude: 51.5052778,
        longitude: -0.0288889,
        title: `West India Dock`,
        short_text: `West India Docks, inland of the Canary Wharf Pier, were built from 1800 to accommodate London's growing trade, including the West Indian sugar and slave trade.`,
        long_text: `The first police force in London “Thames River Police” formed here in 1798 to protect ships from being looted. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi123`,
        latitude: 51.5010556,
        longitude: -0.0401944,
        title: `Stave Hill Ecological Park`,
        short_text: `Stave Hill Ecological Park is an urban ecological park on the site of Russia Dock, which was used to import softwood timber from Sweden, Norway and Russia.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.tcv.org.uk/london/urbanecology/urban-ecology-sites/stave-hill-ecological-park/`,
    },
    {
        id: `poi124`,
        latitude: 51.4763306,
        longitude: -0.0058333,
        title: `Cutty Sark`,
        short_text: `The Cutty Sark is 150 years old. During its years as a British merchant ship, Cutty Sark visited sixteen different countries and travelled the equivalent of two and a half voyages to the moon and back.`,
        long_text: `Cutty Sark was built for the China tea trade but would carry a vast array of cargoes during her career. Cutty Sark carried almost 10 million pounds of tea between 1870 and 1877. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi125`,
        latitude: 51.4851389,
        longitude: -0.00975,
        title: `Greenwich Foot Tunnel`,
        short_text: `Each year, 1.2 million people use this foot tunnel under the Thames linking Greenwich and Millwall.`,
        long_text: `The Greenwich Foot Tunnel was built in 1902 to enable workers to travel easily and safely to the docks and other places of work on the Isle of Dogs, and replaced an unreliable and sometimes dangerous ferry service. Entrances to the tunnels can be seen on both banks of the Thames, marked by distinctive circular brick buildings with glass domes. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Greenwich_foot_tunnel`,
    },
    {
        id: `poi126`,
        latitude: 51.4883333,
        longitude: -0.0044444,
        title: `Isle of Dogs`,
        short_text: `River charity Thames21 records that plastic bags accumulate at this part of the Thames foreshore because they are deposited as the river current slows on the curve.`,
        long_text: `A Thames21 volunteer found a Silver Jubilee bag from 1976 in usable condition. Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/river-foreshore-clean-ups/`,
    },
    {
        id: `poi127`,
        latitude: 51.4831944,
        longitude: -0.0058889,
        title: `Old Royal Naval College`,
        short_text: `Designed by Christopher Wren, this building was built between 1696 and 1712 as the Royal Hospital for Seamen.`,
        long_text: `The building became the Royal Naval College between 1873 and 1998 and is often used as background for film and TV, featuring in The Crown, Les Miserables and Skyfall. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Old_Royal_Naval_College`,
    },
    {
        id: `poi128`,
        latitude: 51.47819756,
        longitude: -0.001458514993,
        title: `Royal Greenwich Observatory`,
        short_text: `The Prime Meridian line at Greenwich divides the world into eastern and western hemispheres`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi129`,
        latitude: 51.5017972,
        longitude: 0.0018806,
        title: `The O2 Arena`,
        short_text: `The Millennium Dome is the original name of the O2 Arena and was built to house a major national exhibition celebrating the beginning of the third millennium in the year 2000.`,
        long_text: `The O2 is the ninth largest building in the world by usable volume. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Millennium_Dome`,
    },
    {
        id: `poi130`,
        latitude: 51.4897222,
        longitude: -0.0030556,
        title: `Isle of Dogs foreshore`,
        short_text: `Thames 21 river clean-up volunteers have found numerous World War II-era empty bullets and shell casings on the Isle of Dogs foreshore.`,
        long_text: `World War II bullets and casings found here are probably the remains of anti-aircraft activity to protect the docks. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi131`,
        latitude: 51.5056944,
        longitude: -0.0026389,
        title: `Blackwall Tunnel`,
        short_text: `Blackwall Tunnel, built between 1892 and 1897, was built in response to the growing need for more road connection across the Thames in the East End.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.british-history.ac.uk/survey-london/vols43-4/pp640-645`,
    },
    {
        id: `poi132`,
        latitude: 51.5090556,
        longitude: 0.0031389,
        title: `East India Dock Basin`,
        short_text: `East India Dock opened in 1806, sponsored by the powerful East India company.`,
        long_text: `The East India Company traded in commodities such as tea, spices, indigo, silk and Persian carpets. The tea trade alone was worth £30 million a year. Local industries like spice merchants and pepper grinders sprung up around the dock to process the imported goods. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/East_India_Docks`,
    },
    {
        id: `poi133`,
        latitude: 51.5090556,
        longitude: 0.0095278,
        title: `Bow Creek`,
        short_text: `Bow Creek is a 3.6 km-long tidal estuary of the River Lea and forms the boundary between the London boroughs of Newham and Tower Hamlets.`,
        long_text: `In the 9th and 10th centuries, the River Lea was the boundary between two cultures: the Vikings (to the east) and the Anglo-Saxons (to the west). Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/River_Lea`,
    },
    {
        id: `poi134`,
        latitude: 51.4944167,
        longitude: 0.0153611,
        title: `Greenwich Peninsula Ecology Park`,
        short_text: `The Greenwich Ecology Park is built on land that was originally agricultural fields and marshes but became heavily industrialised from the late 1880s onwards with gas and chemical works and a major shipbuilding yard.`,
        long_text: `The Blackwall Tunnel, built in 1897, destroyed much of the remaining field and marsh. Sourced by Thames21`,
        website_link: `https://thelandtrust.org.uk/space/greenwich-ecology-park/`,
    },
    {
        id: `poi135`,
        latitude: 51.4952778,
        longitude: 0.0372222,
        title: `Thames Barrier`,
        short_text: `The Thames Barrier is the largest moveable barrier in the world and protects 1.25 million people from the risk of flood.`,
        long_text: `Thames21 co-hosts the Your Tidal Thames Catchment Partnership, which is working with the Environment Agency on its Thames 2100 Plan to address the increased risk of flood caused by climate change. Sourced by Thames21`,
        website_link: `https://www.thamesestuarypartnership.org/your-tidal-thames`,
    },
    {
        id: `poi136`,
        latitude: 51.5093889,
        longitude: 0.1390556,
        title: `Crossness Sewage Treatment Works`,
        short_text: `The opening of the Victorian "cathedral of ironwork", Crossness Sewage Works, was attended by the King and the Archbishops of Canterbury and York.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi137`,
        latitude: 51.4988611,
        longitude: 0.1829722,
        title: `Concrete Barges at Coalharbour`,
        short_text: `Coalharbour is the resting place of 16 World War II concrete barges helping form a flood defence. Hollywood star Zac Efron cleaned up plastic waste here with Thames21!`,
        long_text: `In 1953, 16 World War II concrete barges were used to shore up flood defences after a huge storm and tidal surge and have remained here ever since, home to rock pipits and other birds. Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/2020/07/hollywood-star-zac-efron-joins-forces-with-thames21-to-highlight-londons-plastic-waste-crisis/ https://www.londonriversidebid.co.uk/news-and-events/local-history-concrete-barges-and-the-diver`,
    },
    {
        id: `poi138`,
        latitude: 51.4644722,
        longitude: 0.2572222,
        title: `Dartford Crossing`,
        short_text: `The bases of the Queen Elizabeth bridge were built to be able to withstand the impact of 65,000-tonne boats travelling at 10 knots.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.essexlive.news/news/essex-news/dartford-crossing-fascinating-photos-show-3486088`,
    },
    {
        id: `poi139`,
        latitude: 51.4518889,
        longitude: 0.37475,
        title: `Tilbury Fort`,
        short_text: `Queen Elizabeth I gave a rousing speech at Tilbury Fort in 1588 during the invasion by of the Armada.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi140`,
        latitude: 51.4448333,
        longitude: 0.3686944,
        title: `Gravesend`,
        short_text: `Native American princess Pocahontas first laid foot in England at Gravesend, and is buried here.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi141`,
        latitude: 51.5016667,
        longitude: 0.0472222,
        title: `Tate & Lyle`,
        short_text: `Built in 1878, Tate & Lyle's iconic Thames-side refinery is the largest sugar refinery in the EU and one of the largest in the world, with a capacity of 1.2million tonnes per annum.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.tateandlylesugars.com/about-us/our-locations`,
    },
    {
        id: `poi142`,
        latitude: 51.49825,
        longitude: 0.0597778,
        title: `Woolwich Ferry`,
        short_text: `A ferry has operated on the Thames at Woolwich since the 14th Century, and commercial crossings operated until the mid-19th.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Woolwich_Ferry`,
    },
    {
        id: `poi143`,
        latitude: 51.4951944,
        longitude: 0.0706111,
        title: `Woolwich Arsenal`,
        short_text: `Woolwich Arsenal was established in 1805 to carry out armaments manufacture, ammunition proofing, and explosives research for the British armed forces.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://hidden-london.com/gazetteer/woolwich/`,
    },
    {
        id: `poi144`,
        latitude: 51.5197222,
        longitude: 0.0838889,
        title: `Beckton Sewage Works`,
        short_text: `Beckton Sewage Treatment Works is the largest sewage treatment works in Europe.`,
        long_text: `The Beckton Sewage works were part of Bazelgette's original design for waste treatment in 1864. The works now cover over 250 acres and treat the waste of more than 3.5 million people. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi145`,
        latitude: 51.4518611,
        longitude: 0.3639444,
        title: `London International Cruise Terminal`,
        short_text: `Tilbury Port, is where HMS Windrush docked in 1948, and is now called the London International Cruise Terminal, and was London's passenger liner terminal until the 1960's.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi146`,
        latitude: 51.5078611,
        longitude: 0.0515,
        title: `Royal Albert Docks`,
        short_text: `Royal Albert Docks is undergoing extensive redevelopment. Its use as a commercial dock declined as shipping became containerised and it was closed as a dock in 1981.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi147`,
        latitude: 51.5078611,
        longitude: 0.0515,
        title: `Erith Petrified Forest`,
        short_text: `When the tide is low a 5000 year old petrifed forest is revealed at Erith.`,
        long_text: `At low tide the dark fossilized trunks of a 5000 year-old Neolithic Forest poke up through the muddy bank. For over two thousand years a dense woodland of ash, oak, alder and elm grew along the Thames foreshore till the waters gradually eroded it away. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi148`,
        latitude: 51.4876111,
        longitude: -0.2872222,
        title: `The Oxo Tower`,
        short_text: `Thames21 volunteer Flora's business making beautiful cards with plastic from the river - Washed-Up Cards - started with a clean-up here with a local clean-up leader, Andrea Zick`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.etsy.com/uk/shop/WashedUpCards/; https://www.bbc.co.uk/iplayer/episode/m000t26h/morning-live-series-2-10032021`,
    },
    {
        id: `poi149`,
        latitude: 51.5088889,
        longitude: 0.0075,
        title: `River Lea`,
        short_text: `The River Lea, London's second biggest river, joins the Thames at East India Dock and Trinity Buoy Wharf.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi150`,
        latitude: 51.4833333,
        longitude: -0.0180556,
        title: `Deptford Creek`,
        short_text: `Deptford Creek is the mouth of the River Ravensbourne. Betwen the 16th and 19th centuries many small shipbuilders set up in the creek to serve Deptford Dockyard, a Royal Dockyard created by Henry VIII.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.creeksidecentre.org.uk/about/ https://en.wikipedia.org/wiki/River_Ravensbourne`,
    },
    {
        id: `poi151`,
        latitude: 51.4867222,
        longitude: -0.1306389,
        title: `River Tyburn`,
        short_text: `The River Tyburn could claim to have some royal appointment as it flows directly beneath Buckingham Palace.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi152`,
        latitude: 51.4884167,
        longitude: -0.1283889,
        title: `River Effra`,
        short_text: `Slightly downstream from where the River Effra meets the Thames, low tide reveals wooden posts said to be the remains of a Bronze Age pier used for ceremonies or funerals.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi153`,
        latitude: 51.5108611,
        longitude: 0.1039167,
        title: `River Fleet`,
        short_text: `The River Fleet is considered London's most famous hidden river and today can only be seen exposed on Hampstead Heath.`,
        long_text: `Just after a short cycle lane on Georgiana Street, opposite the Prince Albert pub in Camden is a circular grate in the road. If you peer into the drain cover you should hear and see the River Fleet below. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi154`,
        latitude: 51.5005833,
        longitude: -0.0735,
        title: `River Neckinger`,
        short_text: `River Neckinger evolved in area of south London marshland as a drainage ditch being fed by numerous smaller streams.`,
        long_text: `Before the 19th century, those found guilty of mutiny or pirateering were hanged at a location close to the mouth of the River Neckinger. The name of the river is derived from the hangman's neckerchief/noose. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi155`,
        latitude: 51.494,
        longitude: -0.0324444,
        title: `Earl's Sluice`,
        short_text: `There are two outlets that can be viewed at low water for the 'hidden river' Earl's Sluice to enter the River Thames, one that releases rainwater and the other sewage.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi156`,
        latitude: 51.4876111,
        longitude: -0.0551111,
        title: `River Peck`,
        short_text: `The hidden River Peck is visible for over half a kilometre as it traverses Peckham Rye Park above ground`,
        long_text: `The River Peck meets Earl's Sluice and flows eastwards towards the Thames. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi157`,
        latitude: 51.4805556,
        longitude: 0.2163889,
        title: `River Darent`,
        short_text: `Where the River Darent joins the Thames is called Dartford Creek and marks the end of London.`,
        long_text: `This is the last remaining extensive area of open marsh that exists between London and Gravesend. On the western side of the river are Crayford Marshes in Bexley: on the eastern bank are Dartford Marshes in Kent Sourced by Thames21`,
        website_link: `https://darent-valley.org.uk/the-darent-valley-landscape/natural-landscapes/coastal-marsh/`,
    },
    {
        id: `poi158`,
        latitude: 51.5001111,
        longitude: 0.1483333,
        title: `Erith Salt Marshes`,
        short_text: `Seven of the nine UK red-listed waders can be seen at Erith Marshes.`,
        long_text: `The plant life of the old sea walls in Erith Marshes includes several regionally scarce species; corn parsley, knotted hedge-parsley and narrow-leaved pepperwort. The wetland plant life is also diverse, including horned pondweed, wild celery, lesser reedmace, pink water-speedwell and marsh and water docks, which are all rare in London. Sourced by Thames21`,
        website_link: `https://www.bexleywildlife.org/erith-marshes/`,
    },
    {
        id: `poi159`,
        latitude: 51.4863889,
        longitude: 0.2230556,
        title: `Rainham Marshes`,
        short_text: `To the west of Purfleet in Rainham Marshes, there is hidden forest only visible at low tide of preserved tree trunks from the Neolithic era over 6000 years old. Ash, elm and alder from a long-lost forest were preserved in layer of brown peat beneath the river mud.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://londonist.com/2016/07/secrets-of-the-thames`,
    },
    {
        id: `poi160`,
        latitude: 51.5025278,
        longitude: -0.0601667,
        title: `Execution Dock`,
        short_text: `Execution dock, near the shoreline at Wapping, was used for more than 400 years to execute pirates, smugglers and mutineers sentenced to death by the Admiralty Courts. The corpses were left hanging until at least three tides had washed over their heads.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.m.wikipedia.org/wiki/Execution_Dock`,
    },
    {
        id: `poi161`,
        latitude: 51.5060833,
        longitude: -0.0128056,
        title: `Billingsgate Fish Market`,
        short_text: `Sammy the Harbour Seal, has been visiting the fish market for 12 years where the local fishmongers throw her a fish for her breakfast`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.bbc.co.uk/news/av/uk-21973450`,
    },
    {
        id: `poi162`,
        latitude: 51.5153611,
        longitude: 0.0971111,
        title: `Barking Creek`,
        short_text: `Barking Creek, the mouth of the river Roding, is a vital nursery ground to commercial fish including sea bass, flounder and smelt.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://restorerivers.eu/wiki/index.php?title=Case_study%3ABarking_Creekmouth`,
    },
    {
        id: `poi163`,
        latitude: 51.5103056,
        longitude: -0.0972222,
        title: `The Frost Fairs`,
        short_text: `The first 'official' Frost Fair which took place on the Thames when it was frozen over during the winter of 1607-08, included football, dancing, nine-pin bowling and pubs.`,
        long_text: `The last Frost Fair took place at Blackfriars in 1814 and featured an elephant being led across the river. Sourced by Thames21`,
        website_link: `https://www.historic-uk.com/HistoryUK/HistoryofEngland/The-Thames-Frost-Fairs/`,
    },
    {
        id: `poi164`,
        latitude: 51.5019444,
        longitude: 0.4747222,
        title: `HMS Flake 99`,
        short_text: `In celebration of National Ice Cream Week 2011, Cadbury’s created the HMS Flake 99, a Landrover adapted to be a floating ice cream van. It floated up and down the Thames, playing ‘We Are Sailing’ by Rod Stewart.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi165`,
        latitude: 51.5192573,
        longitude: 0.6242520252,
        title: `Canvey Island`,
        short_text: `Canvey Island is 10 feet below sea level, and before the C17th when Dutch settlers built a drainage system and created a habitable island, was six marshy islands divided by creeks.`,
        long_text: `Research modelling different rates of climate change predict the island could be underwater within 200 years or remain for 2000 years. Sourced by Thames21`,
        website_link: `https://www.echo-news.co.uk/news/14022107.200-years-from-disaster-research-states-canvey-and-southend-could-sink/`,
    },
    {
        id: `poi166`,
        latitude: 51.5008333,
        longitude: 0.6861111,
        title: `Depth of the Thames`,
        short_text: `The depth of the river Thames varies dramatically but is 20 metres at its deepest point.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.londonxlondon.com/river-thames-facts/`,
    },
    {
        id: `poi167`,
        latitude: 51.52407,
        longitude: 0.71874575,
        title: `Southend-on-Sea`,
        short_text: `Home to the world's longest pleasure pier, (over 2km), Southend-on-Sea was an important escape for working class families in the East End in the 19th and early 20th centuries.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi168`,
        latitude: 51.4652778,
        longitude: 0.4327778,
        title: `Coalhouse Fort`,
        short_text: `Coalhouse Fort was built in the 1860's to guard the Lower Thames from seaborne attack`,
        long_text: `Sourced by Thames21`,
        website_link: `http://www.coalhousefort.co.uk/`,
    },
    {
        id: `poi169`,
        latitude: 51.5444,
        longitude: 0.609,
        title: `Hadleigh Castle`,
        short_text: `Hadleigh Castle, now a ruin, was built in the 1200's overlooking the Thames estuary. In Georgian times, its drum towers were used to watch for smugglers.`,
        long_text: `Artist John Constable painted Hadleigh Castle as a ruin largely to test the effect of a dramatic sky on a large scale. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Hadleigh_Castle`,
    },
    {
        id: `poi170`,
        latitude: 51.4541667,
        longitude: 0.6980556,
        title: `Isle of Grain`,
        short_text: `Isle of Grain is the easternmost point of the Hoo Peninsula where the River Medway meets the Thames. No longer an island and now forming part of the peninsula, the area is almost all marshland and is a major habitat for diverse wetland birds.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.google.com/maps/place/Isle+of+Grain/@51.451518,0.7311569,13z/data=!4m13!1m7!3m6!1s0x47d8d658b51ab47b:0x1b411bb782befab2!2sIsle+of+Grain!3b1!8m2!3d51.4602627!4d0.7194676!3m4!1s0x47d8d658b51ab47b:0x1b411bb782befab2!8m2!3d51.4602627!4d0.7194676`,
    },
    {
        id: `poi171`,
        latitude: 51.4759389,
        longitude: 0.6778306,
        title: `London Stone`,
        short_text: `The London Stone by Yantlet Creek is paired with the Crow Stone in Southend-on-Sea to mark a north-south line across the estuary known as the Yantlet Line.`,
        long_text: `The London and Crow stones are both 54 kilometres (34 miles) from London Bridge. The Yantlet Line marked limit of jurisdiction of City of London and still marks that of the Port of London Authority (PLA). Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Yantlet`,
    },
    {
        id: `poi172`,
        latitude: 51.4488889,
        longitude: 0.7452778,
        title: `SS Richard Montgomery`,
        short_text: `At Sheerness-on-Sea the three masts protruding from the waves is the wreck of the SS Richard Montgomery, a US cargo ship that wrecked in August 1944.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/SS_Richard_Montgomery`,
    },
    {
        id: `poi173`,
        latitude: 51.4894667,
        longitude: 0.8740833,
        title: `Sea Reach No. 1 bouys`,
        short_text: `Sea Reach No. 1 bouys mark where the Thames ends and the North Sea begins`,
        long_text: `Sea Reach No. 1 bouys are on the line between Warden Point on the Isle of Sheppey in Kent and Havengore Head in Essex. Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi174`,
        latitude: 51.5258333,
        longitude: 0.6316667,
        title: `Hadleigh Ray`,
        short_text: `On the banks of Hadleigh Ray, or Benfleet Creek as it is known, the remains of the barge Diligent of Faversham, built in 1880, is visible.`,
        long_text: `The Diligent is thought to have been abandoned in the Creek down towards Leigh during the 1930s and drifted to her final berth some time before World War II. Sourced by Thames21`,
        website_link: `https://www.hadleighhistory.org.uk/content/main-subjects/can-you-help/hadleigh-ray`,
    },
    {
        id: `poi175`,
        latitude: 51.45873803,
        longitude: 0.7343674398,
        title: `Medway`,
        short_text: `The River Medway has a catchment area of 930 square miles (2,409 km2), the second largest in southern England after the Thames.`,
        long_text: `Two military actions are named after the river: the Battle of the Medway, during the Roman invasion of Britain, and the Raid on the Medway during the Second Anglo-Dutch War in 1667. Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/Medway https://medwayvalley.org/rivers/protecting-the-medway-catchment/`,
    },
    {
        id: `poi176`,
        latitude: 51.47969526,
        longitude: 0.2174196567,
        title: `Darent Creek`,
        short_text: `The River Darent is a Kentish tributary of the Thames and is fed by the River Cray.`,
        long_text: `As recently as 1996, parts of the Darent dried up completely in the summer months. However, over the last 20 years the Environment Agency has reduced the amount of water that can be taken from the Darent and undertaken work to improve flows, and the Darent has seen a healthy return of population of fish and invertebrates. Sourced by Thames21`,
        website_link: `https://www.londonslostrivers.com/river-darent.html`,
    },
    {
        id: `poi177`,
        latitude: 51.4983333,
        longitude: 0.1810833,
        title: `Concrete barges`,
        short_text: `The highest ever count by a Thames21 volunteering group of plastic bottles in a single day of 4,350 was recorded here in 2017`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.thames21.org.uk/`,
    },
    {
        id: `poi178`,
        latitude: 51.4708333,
        longitude: 0.3245556,
        title: `Grays Beach`,
        short_text: `Local artists and volunteers created a beautiful manadala here - a geometic configuration of symbols used in Eastern religions - from Thames plastic`,
        long_text: `Old Smarties Tube Lids up to 70 years old have been found washed up on Grays Beach after storms by Thames21 volunteering group Gray's Beachcombers. The age can be identified by the type of label on the lids. Sourced by Thames21`,
        website_link: `https://www.facebook.com/Thurrock100`,
    },
    {
        id: `poi179`,
        latitude: 51.4713889,
        longitude: 0.4663889,
        title: `North Kent Marshes`,
        short_text: `The North Kent Marshes is the largest Site of Special Scientific Interest (SSSI) on the Thames estuary.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://en.wikipedia.org/wiki/River_Thames`,
    },
    {
        id: `poi180`,
        latitude: 51.4638889,
        longitude: 0.4786111,
        title: `RSPB Cliffe Pools`,
        short_text: `Cliffe Pools has 75 hectares of grassland on infilled lagoons which is managed for breeding lapwings and redshanks.`,
        long_text: `Cliffe Pools also provides habitat for important invertebrates such as the shrill and brown-banded carder bee. Sourced by Thames21`,
        website_link: `https://www.rspb.org.uk/reserves-and-events/reserves-a-z/cliffe-pools/`,
    },
    {
        id: `poi181`,
        latitude: 51.389763,
        longitude: 1.368606,
        title: `Margate`,
        short_text: `Grey Seals, the UK's largest seal, use Margate's sandbanks as 'haul-out' areas during low tide to rest.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://www.pla.co.uk/assets/thamesecologyposter.pdf`,
    },
    {
        id: `poi182`,
        latitude: 51.47525,
        longitude: 1.0017222,
        title: `Red Sands Forts`,
        short_text: `7 towers built as anti-aircraft defence, still stand in the middle of the estuary and were used as pirate radio stations in the 1960s.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://project-redsand.com/sea-fort-history/pirate-radio`,
    },
    {
        id: `poi183`,
        latitude: 51.4736111,
        longitude: 0.2358333,
        title: `Name of the Thames`,
        short_text: `The name Thames stems from the Latin name 'Tamesis', which itself stems from the old Celtic name for the river, 'Tamesas', which is thought to have meant 'dark'.`,
        long_text: `Sourced by Thames21`,
        website_link: ``,
    },
    {
        id: `poi184`,
        latitude: 51.4944444,
        longitude: 0.7558333,
        title: `Cross channel swimmers`,
        short_text: `Captain Matthew Webb, the first person to swim the English channel, orchestrated betting on his practice swims in the Thames to raise money for his attempt to swim the Channel.`,
        long_text: `Sourced by Thames21`,
        website_link: `https://outdoorswimmer.com/blogs/river-thames-the-wet-windy-history`,
    },
    {
        id: `poi185`,
        latitude: 51.4977778,
        longitude: 0.4983333,
        title: `Sea lamprey`,
        short_text: `The sea lamprey was declared extinct in the 1960s, but in 2009, a boy found a 40cm-long sea lamprey while volunteering with Thames21!`,
        long_text: `The sea lamprey is described as an eel-like creature with a sucker-shaped mouth surrounded by teeth, that pre-dates dinosaurs. Sourced by Thames21`,
        website_link: `http://news.bbc.co.uk/1/hi/england/london/8127483.stm`,
    },
]

export default pointsOfInterest
